import React, { PureComponent } from 'react';
import flow from 'lodash/flow';

import { withBrowserInfo } from '../../../../hocs';
import { withTracking } from '../../provider';

import TileNavigation from './component';

class TileNavigationContainer extends PureComponent {
  render() {
    const {
      locationLinks,
      subCategoryLinks,
      injected: { tracking: { trackButtonClick } = {} } = {},
    } = this.props;

    const componentProps = {
      subCategoryLinks,
      locationLinks,
      trackSubCategoryClick: trackButtonClick
        ? (params) => trackButtonClick('sub_category', params)
        : () => {},
      trackSubCategoryArrowClick: trackButtonClick
        ? (params) => trackButtonClick('sub_category_arrow', params)
        : () => {},
      trackLocationClick: trackButtonClick
        ? (params) => trackButtonClick('location', params)
        : () => {},
      trackLocationArrowClick: trackButtonClick
        ? (params) => trackButtonClick('location_arrow', params)
        : () => {},
    };
    return <TileNavigation {...componentProps} />;
  }
}

export default flow(
  withBrowserInfo,
  withTracking('tile_navigation'),
)(TileNavigationContainer);
